import {combineReducers} from 'redux';

import experiencesampling from './experiencesampling';
import questionnaire from './questionnaire';
import statics from './statics';
import media from './media';
import user from './user';
import activeEsnaps from './esnap';

export const reducers = {
    experiencesampling,
    questionnaire,
    ...statics,
    media,
    user,
    activeEsnaps,
};

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/index.js